import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  Alert,
  Dialog,
  //DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import SuiInput from "components/SuiInput";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiTypography from "components/SuiTypography";

import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

import PlanesPagoApi from "api/planesPagoApi";
import useParametrosGenerales from "hooks/useParametrosGenerales";

const IniciarPlanPagoModal = ({ open, onClose, plan_pago, onSuccess }) => {
  const [error, setError] = useState(undefined);
  const [tipoPlan, setTipoPlan] = useState("");
  const [medioPago, setMedioPago] = useState("");
  const [cuotas, setCuotas] = useState(1);
  const [diaCobro, setDiaCobro] = useState("5");
  const [abonoInicial, setAbonoInicial] = useState(0);
  const [abonoInicialFormatted, setAbonoInicialFormatted] = useState("");
  const [montoTotal, setMontoTotal] = useState(0);
  const [montoTotalFormatted, setMontoTotalFormatted] = useState("");
  const [fechaCompromiso, setFechaCompromiso] = useState(null);
  const { parametros, cargando: cargandoParametros } = useParametrosGenerales();
  // Medios de pago configurables; se conserva el valor guardado aunque ya no esté en la lista
  const mediosPago = parametros.MEDIOS_PAGO.filter((medio) => medio !== "POR DEFINIR");
  if (medioPago && medioPago !== "POR DEFINIR" && !mediosPago.includes(medioPago)) {
    mediosPago.push(medioPago);
  }

  // Si el día de cobro por defecto no está entre los configurados, se toma el primero
  useEffect(() => {
    const diasCobro = parametros.DIAS_COBRO_PLAN;
    if (!cargandoParametros && diasCobro.length && !diasCobro.includes(Number(diaCobro))) {
      setDiaCobro(String(diasCobro[0]));
    }
  }, [cargandoParametros]);

  const fetchPlanPago = async () => {
    try {
      const response = await PlanesPagoApi.obtenerPlanPagoById(plan_pago.id);
      setTipoPlan(response.data.tipo);
      setMedioPago(response.data.medio_pago);
      setAbonoInicial(response.data.abono_inicial);
      setCuotas(response.data.cuotas);
      setMontoTotal(response.data.monto_total);
      //setFechaCompromiso(response.data.fecha_compromiso || null);
    } catch (error) {
      console.error("Error al obtener el Plan de Pago:", error);
      setError(obtenerMensajeError(error, "Error al obtener el Plan de Pago."));
    }
  };

  useEffect(() => {
    if (plan_pago) {
      fetchPlanPago();
    }
  }, [plan_pago]);

  const hcCuotas = (e) => {
    const value = e.target.value;
    if (value < 1 || value > 10) return;
    setCuotas(value);
  };

  const formatCurrency = (value) => {
    const number = value.replace(/\D/g, "");
    const numberValue = Number(number);
    const formatter = new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: "COP",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return {
      formatted: formatter.format(number || 0).replace(/\s/g, ""),
      value: numberValue,
    };
  };

  const handleMoneyChange = (field) => (event) => {
    const { formatted, value } = formatCurrency(event.target.value);
    if (field === "abono_inicial" && value > 0) {
      setAbonoInicial(value);
      setAbonoInicialFormatted(formatted);
    }
    if (field === "monto_total" && value > 0) {
      setMontoTotal(value);
      setMontoTotalFormatted(formatted);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Validaciones
    if (tipoPlan === "" || tipoPlan === "POR DEFINIR") {
      setError("Debes registrar un Tipo de Plan de Pago.");
      return;
    }
    if (tipoPlan === "CREDITO" && Number(abonoInicial) > Number(montoTotal)) {
      setError(
        "El tipo de plan es CREDITO, por ende el Abono Inicial debe ser menor que el Monto Total."
      );
      return;
    }
    //if (!(Number(montoTotal) > 0)) {
    if (!montoTotal || isNaN(montoTotal) || Number(montoTotal) <= 0) {
      setError("Debes registrar un Monto Total válido y mayor a 0 para el Plan de Pago.");
      return;
    }
    if (fechaCompromiso === null) {
      setError("Debes registrar una Fecha de Compromiso para el Plan de Pago.");
      return;
    }
    if (tipoPlan === "CREDITO" && !(Number(cuotas) >= 1 && Number(cuotas) <= 10)) {
      setError("El tipo de plan es CREDITO, la cantidad de Cuotas debe estar entre 1 y 10.");
      return;
    }
    const datos = {
      operacion: "INICIAR_PLAN_PAGO",
      id_plan_pago: plan_pago.id,
      proceso: plan_pago.proceso,
      estado: true,
      tipo: tipoPlan,
      medio_pago: medioPago,
      dia_cobro: diaCobro,
      cuotas: tipoPlan === "CONTADO" ? 1 : cuotas,
      abono_inicial: tipoPlan === "CONTADO" ? montoTotal : abonoInicial,
      monto_total: montoTotal,
      fecha_compromiso: fechaCompromiso,
    };
    //console.log("AUTORIZAR.datos: " + JSON.stringify(datos));
    if (window.confirm("¿Está seguro(a) de INICIAR el Plan de Pago?")) {
      try {
        const response = await PlanesPagoApi.operarPlanPago(datos);
        if (response.status === 201 && response.data) {
          alert("Plan de Pago iniciado éxitosamente.");
          setError(undefined);
          onSuccess();
        }
      } catch (error) {
        console.error(`Error al Iniciar el Plan de Pago:`, error);
        setError(`Error al Iniciar el Plan de Pago.`);
      }
    }
  };

  const hCClose = () => {
    setError(undefined);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>{error && <Alert severity="error">{error}</Alert>}</Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }} sx={{ mb: 2 }}>
            <Grid size={12}>
              <SuiBox display="left" justifyContent="left" alignItems="left" gap={1}>
                <SuiTypography variant="h3" fontWeight="dark">
                  INICIAR PLAN DE PAGO
                </SuiTypography>
                <SuiTypography variant="h4" fontWeight="dark">
                  Proceso: {plan_pago ? plan_pago.proceso_identificador : "No tiene Proceso"}
                  <br />
                  Cliente: {plan_pago ? plan_pago.cliente_nombre : "No tiene Cliente"}
                </SuiTypography>
              </SuiBox>
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiBox mb={1}>
                <InputLabel>Tipo Plan *</InputLabel>
                <FormControl fullWidth>
                  <Select
                    name="tipo_plan"
                    value={tipoPlan}
                    onChange={(e) => setTipoPlan(e.target.value)}
                    label="Tipo Plan"
                  >
                    <MenuItem value="">Seleccione un Tipo Plan</MenuItem>
                    <MenuItem value="POR DEFINIR">POR DEFINIR</MenuItem>
                    <MenuItem value="CONTADO">CONTADO</MenuItem>
                    <MenuItem value="CREDITO">CREDITO</MenuItem>
                  </Select>
                </FormControl>
              </SuiBox>
            </Grid>
            <Grid size={6}>
              <SuiBox mb={1}>
                <InputLabel>Medio Pago *</InputLabel>
                <FormControl fullWidth>
                  <Select
                    name="medio_pago"
                    value={medioPago}
                    onChange={(e) => setMedioPago(e.target.value)}
                  >
                    <MenuItem value="">Seleccione un Medio de Pago</MenuItem>
                    <MenuItem value="POR DEFINIR">POR DEFINIR</MenuItem>
                    {mediosPago.map((medio) => (
                      <MenuItem key={medio} value={medio}>
                        {medio}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </SuiBox>
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiBox mb={1}>
                <InputLabel>Monto Total *</InputLabel>
                <SuiInput
                  value={montoTotalFormatted}
                  onChange={handleMoneyChange("monto_total")}
                  placeholder="Monto de la Deuda"
                  fullWidth
                />
              </SuiBox>
            </Grid>
            <Grid size={6}>
              <SuiBox mb={1}>
                <InputLabel>Fecha Compromiso *</InputLabel>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={fechaCompromiso}
                    format="DD/MM/YYYY"
                    onChange={(newValue) => {
                      setFechaCompromiso(newValue);
                      setError(undefined);
                    }}
                    fullWidth
                    textField={(params) => (
                      <SuiInput
                        {...params}
                        placeholder="Fecha Compromiso"
                        icon={{
                          component: <CalendarTodayIcon />,
                          direction: "right",
                        }}
                        customClass="custom-date-picker-input"
                      />
                    )}
                  />
                </LocalizationProvider>
              </SuiBox>
            </Grid>
          </Grid>
          {tipoPlan === "CREDITO" && (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={4}>
                <SuiBox mb={1}>
                  <InputLabel>Abono Inicial *</InputLabel>
                  <SuiInput
                    value={abonoInicialFormatted}
                    onChange={handleMoneyChange("abono_inicial")}
                    placeholder="Monto de la Deuda"
                    fullWidth
                  />
                </SuiBox>
              </Grid>
              <Grid size={4}>
                <SuiBox mb={1}>
                  <InputLabel>Cant. Cuotas * (Max. 10)</InputLabel>
                  <SuiInput
                    type="number"
                    value={cuotas}
                    onChange={hcCuotas}
                    fullWidth
                    inputProps={{ min: 1, max: 10 }}
                  />
                </SuiBox>
              </Grid>
              <Grid size={4}>
                <SuiBox mb={1}>
                  <InputLabel>Dia Cobro *</InputLabel>
                  <FormControl fullWidth>
                    <Select
                      name="dia_cobro"
                      value={diaCobro}
                      onChange={(e) => setDiaCobro(e.target.value)}
                      label="Día Cobro"
                    >
                      <MenuItem value="">Seleccione un Día Cobro</MenuItem>
                      {parametros.DIAS_COBRO_PLAN.map((dia) => (
                        <MenuItem key={dia} value={String(dia)}>
                          {dia}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </SuiBox>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <SuiButton onClick={hCClose} buttonColor="light">
            Cancelar
          </SuiButton>
          <SuiButton type="submit" variant="gradient" buttonColor="dark">
            Iniciar Plan
          </SuiButton>
        </DialogActions>
      </form>
    </Dialog>
  );
};

IniciarPlanPagoModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  plan_pago: PropTypes.object,
  onSuccess: PropTypes.func.isRequired,
};

export default IniciarPlanPagoModal;
